<template>

<div class="outer-img-container" :style="{'width':width,'height':height}">
    <div class="img-container" :style="{'width':width,'height':height}">
        <img id="image" :style="{'width':width,'height':height}" :src='$common.HOST+"/resources/"+file.fileinfo.data.file.filename' v-if="file&&file.type==THUMBNAIL_TYPE_IMAGE" style="position:relative"/>
        <div :style="{'width':width,'height':height}" v-if="file&&file.type==THUMBNAIL_TYPE_ICON" style="position:relative">
            <IconComponent :icon="file.data"></IconComponent>
        </div>
    </div>
</div>

</template>

<script>
import IconComponent from './Icon.vue'
export default {
  name: 'InlineImage',
  components: {
    IconComponent
  },
  data(){
    return {
      THUMBNAIL_TYPE_ICON:1,
      THUMBNAIL_TYPE_IMAGE:2
    }
  },
  props: {
    file: null,
    height: null,
    width: null
  },
  methods:{
    
  },
  updated(){

      

  },
  mounted(){


  },
  created(){
    
    

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.outer-img-container{
    display: flex;
    justify-content: center;
}
.img-container{
    position: relative;
}    
 
</style>
